import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import TileContainer from "../../../Tile/v3/components/AvailabilityCalendar/Tile/TileContainer.js";
/* empty css                          */
const AvailabilityCalendar = ({
  id = "availability-calendar",
  className,
  labels,
  range,
  tileNames,
  showPastButton = true,
  showFutureButton = true,
  onClickPastButton,
  onClickFutureButton,
  onClickTile,
  tiles,
  noTimeSlots,
  loading = false,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, id, className: classnames("availability-calendar", className) }, /* @__PURE__ */ React.createElement("div", { className: "availability-calendar__header" }, /* @__PURE__ */ React.createElement("div", { className: "availability-calendar__header-button-container" }, showPastButton && /* @__PURE__ */ React.createElement(
  "button",
  {
    className: "availability-calendar__header-button",
    "aria-label": labels.pastButton,
    "aria-controls": `${id}__tiles`,
    onClick: onClickPastButton
  },
  /* @__PURE__ */ React.createElement(Icon, { name: "chevron-left" })
)), /* @__PURE__ */ React.createElement("span", { className: "availability-calendar__range" }, range), /* @__PURE__ */ React.createElement("div", { className: "availability-calendar__header-button-container" }, showFutureButton && /* @__PURE__ */ React.createElement(
  "button",
  {
    className: "availability-calendar__header-button",
    "aria-label": labels.futureButton,
    "aria-controls": `${id}__tiles`,
    onClick: onClickFutureButton
  },
  /* @__PURE__ */ React.createElement(Icon, { name: "chevron-right" })
)), /* @__PURE__ */ React.createElement("div", { className: "availability-calendar__tile-names" }, tileNames?.map((name) => /* @__PURE__ */ React.createElement("span", { key: name, className: "availability-calendar__tile-name" }, name)))), !loading && noTimeSlots ? /* @__PURE__ */ React.createElement("div", { className: "availability-calendar__no-timeslots", "aria-live": "polite" }, noTimeSlots) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { id: `${id}__tiles`, className: "availability-calendar__tiles", "aria-live": "polite" }, tiles.map(
  (week) => week.map((tile) => /* @__PURE__ */ React.createElement(
    TileContainer,
    {
      ...tile,
      key: tile.date.getTime(),
      loading,
      onClick: onClickTile
    }
  ))
)), /* @__PURE__ */ React.createElement("div", { className: "availability-calendar__legend" }, /* @__PURE__ */ React.createElement("span", { className: "availability-calendar__legend-dot" }), /* @__PURE__ */ React.createElement(Text, { variant: "caption-head" }, labels.legend))));
export {
  AvailabilityCalendar as default
};
//# sourceMappingURL=AvailabilityCalendar.js.map
